import _ from "lodash";

export function arrayMove(arr, oldIndex, newIndex) {
	if (newIndex >= arr.length) {
		let k = newIndex - arr.length + 1;
		while (k--) {
			arr.push(undefined);
		}
	}
	arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
	return arr;
}

// compares if there are any changes in two arrays
export function compareChangesInArrays(oldArr, newArr) {
	return _.difference(newArr, oldArr).length || _.difference(oldArr, newArr).length;
}
